module.exports = __webpack_public_path__ + "img/profile_jf_l2.21a9d142.jpg";